import { EventBus } from '../../core/EventBus.js';
import { Modal }    from './Modal.js';

/**
 * Show a notification toast instead of a native alert().
 * @param {string} message
 * @param {'warning'|'error'|'info'|'success'} [type='warning']
 */
export function showAlert(message, type = 'warning') {
  EventBus.emit('ui:notification', { message, type });
}

/**
 * Show a modal confirmation dialog instead of native confirm().
 * Returns a Promise<boolean>.
 * @param {string} message
 * @param {{ title?: string, confirmLabel?: string, cancelLabel?: string }} opts
 */
export function showConfirm(message, { title = 'Confirm', confirmLabel = 'Yes', cancelLabel = 'Cancel' } = {}) {
  return new Promise(resolve => {
    const id = 'confirm-dialog-' + Date.now();
    const modal = new Modal(id, {
      title,
      onClose: () => {
        resolve(false);
        cleanup();
      }
    });

    modal.setBody(`
      <p style="margin: 0 0 1rem; line-height: 1.5">${message}</p>
      <div style="display: flex; gap: 0.5rem; justify-content: flex-end">
        <button class="btn btn-sm" id="${id}-cancel">${cancelLabel}</button>
        <button class="btn btn-sm btn-primary" id="${id}-confirm">${confirmLabel}</button>
      </div>
    `);

    function cleanup() {
      setTimeout(() => { if (modal.el?.parentNode) modal.el.remove(); }, 200);
    }

    modal.el.querySelector(`#${id}-cancel`).addEventListener('click', () => {
      modal.close();
    });

    modal.el.querySelector(`#${id}-confirm`).addEventListener('click', () => {
      resolve(true);
      modal.close();
      cleanup();
    });

    modal.open();
  });
}
